import { ReactComponent as ScienceIcon } from 'resources/images/science.svg'
import { ReactComponent as MathIcon } from 'resources/images/math.svg'
import { ReactComponent as GeographyIcon } from 'resources/images/geography.svg'
import { ReactComponent as HistoryIcon } from 'resources/images/history.svg'
import { ReactComponent as StoryComprehensionIcon } from 'resources/images/story_comprehension.svg'
import { ReactComponent as SportsIcon } from 'resources/images/sports.svg'
import { ReactComponent as JokeIcon } from 'resources/images/joke.svg'
import { ReactComponent as OpenConversationsIcon } from 'resources/images/open_conversation.svg'
import { message } from 'antd'

export const getErrorMessage = (error) => {
    return error?.response_json?.error?.message || error
}

export const ENABLED_TOPICS = ["math", "science", "geography", "economics"]

export const TOPICS = [
    {
        topic: "economics",
        label: "Economics",
        color: "#ffe7d1",
        icon: HistoryIcon
    },
    {
        topic: "math",
        label: "Math",
        color: "#ffe7d1",
        icon: MathIcon
    },
    {
        topic: "science",
        label: "Science",
        color: "#fcf4fd",
        icon: ScienceIcon
    },
    {
        topic: "geography",
        label: "Geography",
        color: "#f7fae9",
        icon: GeographyIcon
    },
    {
        topic: "history",
        label: "History",
        color: "#e2f8f2",
        icon: HistoryIcon
    },
    {
        topic: "story-comprehension",
        label: "Story Comprehension",
        color: "#f4f9fd",
        icon: StoryComprehensionIcon
    },
    {
        topic: "sports",
        label: "Sports",
        color: "#ffe4db",
        icon: SportsIcon
    },
    {
        topic: "joke",
        label: "Joke",
        color: "#f2e8fe",
        icon: JokeIcon
    },
    {
        topic: "",
        label: "Open Conversations",
        color: "#e9f5ee",
        icon: OpenConversationsIcon
    },
]

export const GRADES = [
    {
        label: "Kindergarten",
        value: "Kindergarten",
    },
    {
        label: "Grade 1",
        value: "Grade 1",
    },
    {
        label: "Grade 2",
        value: "Grade 2",
    },
    {
        label: "Grade 3",
        value: "Grade 3",
    },
    {
        label: "Grade 4",
        value: "Grade 4",
    },
    {
        label: "Grade 5",
        value: "Grade 5",
    },
    {
        label: "Grade 6",
        value: "Grade 6",
    },
    {
        label: "Grade 7",
        value: "Grade 7",
    },
    {
        label: "Grade 8",
        value: "Grade 8",
    },
    {
        label: "Grade 9",
        value: "Grade 9",
    },
    {
        label: "Grade 10",
        value: "Grade 10",
    },
    {
        label: "Grade 11",
        value: "Grade 11",
    },
    {
        label: "Grade 12",
        value: "Grade 12",
    },
    {
        label: "Adult",
        value: "Adult"
    },
]

export const showErrorToast = (messageString: string) => {
    message.error(messageString);
}

export const showSuccessToast = (messageString: string) => {
    message.success(messageString);
}